export const servicesContent = {
  hero: {
    title: "More Ways We Can Help! 🤗",
    subtitle: "Amazing services coming your way"
  },
  comingSoon: {
    imageAlt: "Beavers working on science",
    title: "We're Cooking Up Something Great! 👨‍🍳",
    description1: "We're working on setup help, family coaching (yes, really!), custom integrations, and even professional installation services. Because sometimes you just want someone else to figure out where to hang the screen! 😊",
    description2: "Want to chat about what we're planning? Reach out! We love talking to families about how we can make FamilyCast work perfectly for your unique household!",
    buttons: {
      docs: "View Documentation",
      pricing: "See Pricing",
      contact: "Contact Us"
    }
  }
};
